import React, { useState, useEffect } from "react";
import style from "charts/shared.module.scss";
import Box from "components/box";
import * as d3 from "d3";
import data from "../thrive_data.csv";
import { Waypoint } from "react-waypoint";

const numberFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0
});
const toDollars = number => numberFormatter.format(number);

const AnnualSpend = () => {
  const [Data, setData] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    d3.csv(data).then(function(data) {
      var unsorted = [];
      var temp = [];

      var filtered = data.filter(function(d) {
        return d.Q100 !== "";
      });

      d3.group(filtered, d => d.Q2).forEach(function(value, key) {
        temp.push({ x: key, y: value });
      });

      temp.forEach(function(value) {
        var values = [];
        var size = [];
        var order = { "Seed-A": 1, "B-C": 2, "D+": 3 };
        var label = {
          "Seed-A": "Seed - Series A",
          "B-C": "Series B-C",
          "D+": "Series D+"
        };
        value.y.forEach(function(val) {
          values.push(parseFloat(val.Q100));
          size.push(parseFloat(val.Q100) / parseFloat(val.Q4));
        });
        unsorted.push({
          order: order[value.x],
          x: label[value.x],
          y: values,
          hover:
            "Avg HR Spend/FTE " +
            toDollars(Math.round(d3.mean(size) / 1000) * 1000),
          mean: "Avg " + toDollars(Math.round(d3.mean(values) / 1000) * 1000),
          hover2:
            "Range " +
            toDollars(Math.round(d3.min(values) / 1000) * 1000) +
            "-" +
            toDollars(Math.round(d3.max(values) / 1000) * 1000),
          hover3:
            "25th percentile " +
            toDollars(Math.round(d3.quantile(values, 0.25) / 1000) * 1000),
          hover4:
            "75th percentile " +
            toDollars(Math.round(d3.quantile(values, 0.75) / 1000) * 1000)
        });
      });

      function compare(a, b) {
        if (a.order < b.order) {
          return -1;
        }
        if (a.order > b.order) {
          return 1;
        }
        return 0;
      }

      var Data = unsorted.sort(compare);

      // setData(Data);
      var dummy_data = JSON.parse(JSON.stringify(Data));

      dummy_data.forEach((d, i) => {
        d.y = [0, 0, 0, 0];
      });

      load ? setData(Data) : setData(dummy_data);

      // console.log(Data);
    });
  }, [load]);

  return (
    <Waypoint onEnter={() => setLoad(true)} onLeave={() => setLoad(false)}>
      <div className={style.container}>
        <h4 className={style.chart_title}>
          <span className="hover_text">
            Annual HR Spend
            <span className="tooltip" style={{ width: `300px` }}>
              HR Spend includes all people team expenses including HR tech,
              recruiting agencies, offsites and team events, DEI-related
              expenses, and L&D. Compensation and benefits costs are not
              included.{" "}
            </span>{" "}
          </span>
        </h4>
        <div className={style.row}>
          <div className={style.left__header_row}>
            <div className={style.title__sm}>Stage</div>
          </div>
          <div className={style.right__header_row}>
            <div className={style.title}>Budget</div>
          </div>
        </div>

        {Data.map(row => (
          <div className={style.row} key={row.x + "spend"}>
            <div className={style.left}>
              <span className={style.tool}>
                {row.x}
                <span className={style.tooltip} style={{ width: `140px` }}>
                  {row.hover}
                </span>
              </span>
            </div>
            <div className={style.right}>
              <span className={style.toolbox}>
                <Box
                  value={row.y}
                  maxDomain={10000000}
                  // maxLabel={row.mean}
                  anchor={"left"}
                />
                <span
                  className={style.tooltip}
                  style={{
                    left: `${parseInt(d3.mean(row.y)) / 10000}px`,
                    width: `145px`,
                    top: `60px`
                  }}
                >
                  {row.mean}
                  <br />
                  {row.hover2}
                  <br />
                  {row.hover3}
                  <br />
                  {row.hover4}
                </span>
              </span>
            </div>
          </div>
        ))}
        <div className={style.axis}>
          <div className={style.axis_item}>$0</div>
          <div className={style.axis_item}>$5M</div>
          <div className={style.axis_item}>$10M</div>
        </div>
      </div>
    </Waypoint>
  );
};

export default AnnualSpend;
